var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcMiniMarketNew = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25.658,
  height: 23.353,
  viewBox: "0 0 25.658 23.353",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2,.cls-4{fill:none}.cls-1,.cls-2{stroke:#5f7278;stroke-width:1.5px}.cls-1{fill-rule:evenodd}.cls-3{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_mini_market",
  transform: "translate(.75 .75)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  d: "M3.15 2.55L1.624 8.7a2.388 2.388 0 0 0 2.318 2.964 3.226 3.226 0 0 0 2.692-1.444l.528-.795.528.795a3.231 3.231 0 0 0 5.385 0l.528-.795.528.795a3.231 3.231 0 0 0 5.385 0l.528-.795.528.795a3.226 3.226 0 0 0 2.692 1.444 2.388 2.388 0 0 0 2.32-2.964l-1.526-6.15z",
  className: "cls-1",
  transform: "translate(-1.554 -2.55)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_248",
  d: "M3.613 14.713v12.8h13.8v-8.125h4.733v8.126h3.344V14.388",
  className: "cls-2",
  "data-name": "Path 248",
  transform: "translate(-2.475 -5.661)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_227",
  className: "cls-2",
  "data-name": "Rectangle 227",
  transform: "translate(3.962 13.778)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 5,
  className: "cls-3",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 6.5,
  height: 3.5,
  x: 0.75,
  y: 0.75,
  className: "cls-4",
  rx: 1.25
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcMiniMarketNew);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_mini_market_new.c0fe3a4d0b6a5d7631cf4cdfe24a1ca6.svg";